import { ROUTES_PATH } from 'app/constants/Routes';

/**
 * Rotas liberadas para o usuário do plano academy (aluno).
 *
 * O menu esconde o que ele não usa, mas esconder item de menu não protege rota:
 * hoje nenhuma rota do app tem guarda por plano, então `/meus-processos` e
 * companhia continuam abrindo por deep link, favorito ou histórico. Esta lista
 * é a allowlist que o `BasePage` usa para devolver o aluno à home dele.
 *
 * Inclui as ferramentas dele (Início, Carreira, Estudos, o Academy, Cursos, IA
 * da Jusfy e Jurisprudência) e o mínimo que todo
 * usuário logado precisa: perfil, plano/pagamento, segurança, logout e erro.
 */
const ACADEMY_ALLOWED_PATHS = [
  ROUTES_PATH.MAIN.DASHBOARD,
  ROUTES_PATH.MAIN.GPT,
  ROUTES_PATH.MAIN.JURISPRUDENCIA,
  ROUTES_PATH.MAIN.ESTUDOS,
  ROUTES_PATH.MAIN.CARREIRA,
  ROUTES_PATH.MAIN.ACADEMY,
  ROUTES_PATH.JUSCLASS.BASE,
  ROUTES_PATH.CONFIGURACOES.ACCOUNT_PROFILE,
  ROUTES_PATH.CONFIGURACOES.PLAN_AND_PAYMENT,
  ROUTES_PATH.CONFIGURACOES.SECURITY,
  '/logout',
  '/error',
];

export function isAcademyAllowedPath(pathname: string): boolean {
  return ACADEMY_ALLOWED_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

export function getAcademyRedirectPath(): string {
  return ROUTES_PATH.MAIN.DASHBOARD;
}
